import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import FormModal from "../FormModal/FormModal";

// progress (0-100) is only known once bytes are actually streaming in
// (the zipping step); before that, e.g. while the backend job is running,
// it's left undefined and an indeterminate spinner is shown instead.
const ProcessingPopup = ({ title, loading, progress, onClose }) => (
  <FormModal
    open
    onClose={loading ? undefined : onClose}
    title={title}
  >
    {loading &&
      (typeof progress === "number" ? (
        <div style={{ marginTop: "20px" }}>
          <LinearProgress variant="determinate" value={progress} />
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress style={{ marginTop: "20px" }} />
        </div>
      ))}
  </FormModal>
);

export default ProcessingPopup;
